var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.67386 29.3086H0V31.0348H1.67386V29.3086Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32.761V34.4826V36.2088H1.67386V34.4826H3.34333V32.761H1.67386H0Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34809 25.8608H5.01756V27.5825H6.69142V25.8608H13.3781V24.1347H8.36089V20.6869H6.69142V18.9652H8.36089V17.239H3.34809V15.5129H-0.0171509V17.239H1.6567V18.9652H-0.0171509V27.5825H1.6567V29.3086H3.33056V25.8608H3.34809ZM6.69142 24.1347H3.34809V22.413H6.69142V24.1347Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01718 13.7912H3.34332V15.5174H5.01718V13.7912Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01718 29.3086H3.34332V31.0348V32.761H5.01718H6.68665V31.0348H5.01718V29.3086Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3605 34.4826H6.68665V36.2088H8.3605V34.4826Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.03 15.5174H11.7038V13.7912H10.03H8.3605H6.68665V15.5174H8.3605V17.2436H10.03V15.5174Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0344 18.9652H8.36053V20.6914H10.0344V18.9652Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3605 29.3086V27.587H6.68665V29.3086V31.0348H8.3605H10.03V29.3086H8.3605Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0344 32.761H8.36053V34.4871H10.0344V32.761Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7038 18.9652V20.6914H13.3733V18.9652V17.2436H11.7038H10.03V18.9652H11.7038Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7038 20.6914H10.03V22.4175H11.7038V20.6914Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7038 27.587H10.03V29.3131H11.7038V27.587Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7038 31.0348H10.03V32.761H11.7038V31.0348Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 10.3434H13.3733V12.0696H15.0471V10.3434Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 15.5174V13.7912H13.3733V15.5174V17.2436H15.0471V15.5174Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 20.6914H13.3733V22.4175H15.0471V20.6914Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 44.826H13.3733V46.5522H15.0471V44.826Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.721 6.89562H18.3861V10.3434H20.0556V15.5129H21.7294V13.7732H25.0728V10.3434H26.7422V12.0651H28.4161V8.61726H26.751V5.18753H28.4249V1.72165H30.0943V0H25.0815V1.72165H26.751V3.44781H25.0815V5.18753H23.4077V6.91369H25.0815V8.63534H23.4077V6.89562H21.7382V8.61726H20.0643V6.89562H21.7382V5.18753H23.4077V3.44781H21.7382V1.72165H23.4077V0H18.3861V1.72165H20.0556V3.44781H18.3861V5.18753H15.0472V6.91369H13.3777V8.63534H15.0472V10.3615H16.721V6.89562ZM23.4077 10.3434V12.0651H21.7382V10.3434H23.4077Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 41.3782V39.6566H13.3733V41.3782V43.1044H15.0471H16.721V44.826V46.5522H18.3905V44.826V43.1044V41.3782V39.6566H16.721V41.3782H15.0471Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.721 1.72616H15.0471H13.3733V3.44781H15.0471H16.721H18.3905V1.72616H16.721Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3905 12.0696V10.3434H16.721V12.0696V13.7912V15.5174H18.3905V13.7912V12.0696Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3905 20.6914V18.9652H16.721H15.0472V20.6914H16.721H18.3905Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.721 48.2738V46.5522H15.0472V48.2738V50H16.721H18.3905H20.0644H21.7338H23.4077H25.0772H26.751H28.4205H30.0944H31.7682H33.4377H35.1115H36.781H38.4549V48.2738H36.781H35.1115H33.4377H31.7682H30.0944H28.4205V46.5522H26.751V48.2738H25.0772V46.5522H23.4077V48.2738H21.7338H20.0644V46.5522H18.3905V48.2738H16.721Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0644 17.2436V15.5174H18.3905V17.2436V18.9652H20.0644V17.2436Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3861 29.3086V25.8608H16.721V24.1347H18.3861V22.413H15.0472V27.5825H13.3777V29.3086H16.721V31.0303H18.3861V32.7519H16.721V31.0258H15.0472V32.7519H13.3777V34.4781H10.0344V36.1997H13.3777V37.9259H15.0472V39.6475H16.721V37.9259H20.0644V36.1997H21.7382V34.4781H20.0644V31.0258H21.7382V29.3041H18.3861V29.3086ZM18.3861 36.2042H15.0472V34.4826H18.3861V36.2042Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7382 39.6566H20.0643V41.3827H21.7382V39.6566Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7338 41.3782V43.1044H23.4077H25.0772V41.3782H23.4077H21.7338Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4077 44.826H21.7338V46.5522H23.4077V44.826Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.751 20.6914V18.9652V17.2436H25.0772H23.4077V18.9652H21.7338H20.0644V20.6914H18.3905V22.413H20.0644V24.1392H21.7338V22.413V20.6914H23.4077V22.413H25.0772V20.6914H26.751Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.751 43.1044H25.0771V44.8305H26.751V43.1044Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4249 20.6914H26.751V22.4175H28.4249V20.6914Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.751 31.0348V29.3086V27.587H28.4205V25.8608V24.1392H26.751V22.413H25.0772V24.1392H23.4077H21.7338V25.8608H23.4077V27.587H21.7338V29.3086H23.4077V31.0348H25.0772V32.761H26.751H28.4205V31.0348H26.751Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4205 8.62178H30.0943H31.7682V6.89562H30.0943V5.17397H28.4205V6.89562V8.62178Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0943 32.761H28.4205V34.4826H26.751H25.0772H23.4077V36.2088H25.0772V37.9304H23.4077H21.7338V39.6566H23.4077H25.0772V41.3782H26.751H28.4205V39.6566H26.751V37.9304V36.2088H28.4205V37.9304V39.6566H30.0943V37.9304V36.2088H31.7682V34.4826H30.0943V32.761Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0943 41.3782H28.4205V43.1044H30.0943V41.3782Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7682 12.0696V10.3434H30.0944V12.0696V13.7912H31.7682V12.0696Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7682 22.413H30.0944V24.1392H31.7682V22.413Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0943 27.587H28.4205V29.3086H30.0943H31.7682V27.587H30.0943Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7682 46.5522V44.826H30.0943H28.4205V46.5522H30.0943H31.7682Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4377 5.17397H35.1115V3.44781V1.72616V0H33.4377V1.72616V3.44781H31.7682H30.0944V5.17397H31.7682H33.4377Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4377 10.3434V12.0696V13.7912H35.1115V12.0696V10.3434V8.62178V6.89562H33.4377V8.62178H31.7682V10.3434H33.4377Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7682 15.5174H30.0944V13.7912H28.4205V15.5174H26.751V17.2436H28.4205V18.9652V20.6914H30.0944V18.9652H31.7682V20.6914V22.413H33.4377V24.1392H35.1116H36.781V22.413H35.1116V20.6914H33.4377V18.9652H35.1116V17.2436H33.4377V15.5174V13.7912H31.7682V15.5174Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.442 24.1392H31.7682V25.8653H33.442V24.1392Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7854 13.7912H35.1115V15.5174H36.7854V13.7912Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7854 44.826H35.1115V46.5522H36.7854V44.826Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4549 37.9304H36.781V39.6566H38.4549V37.9304Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1243 29.3086H41.7982V27.587H40.1243H38.4549V29.3086H40.1243Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4548 32.7519V31.0258H36.7898V27.5779H38.4592V25.8608H43.4764V18.9652H41.8026V20.6869H40.1331V18.9652H41.8026V13.7732H40.1331V15.4948H38.4548V18.9471H36.7898V20.6869H38.4592V24.1347H36.7898V25.8608H33.4464V27.5825H35.1159V29.3086H31.7682V31.0303H33.442V32.7519H31.7682V34.4781H33.442V43.0999H38.4548V44.826H40.1287V43.0999H41.7982V41.3782H43.472V39.6521H41.7982V32.7519H38.4548ZM40.1287 37.9259V41.3737H35.1115V36.2042H40.1287V37.9259Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4677 29.3086H41.7982V31.0348V32.761H43.4677V34.4826V36.2088V37.9304H45.1415H46.811V36.2088H48.4848V34.4826V32.761H46.811H45.1415V31.0348H43.4677V29.3086Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8154 13.7912H45.1415V15.5174H46.8154V13.7912Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 25.8608H43.4677V27.587H45.1415V29.3086V31.0348H46.811H48.4848V29.3086H46.811V27.587V25.8608V24.1392H45.1415V25.8608Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8154 39.6566H45.1415V41.3827H46.8154V39.6566Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 46.5522V44.826H43.4677H41.7982V46.5522H40.1243V48.2738V50H41.7982V48.2738H43.4677V50H45.1415H46.811V48.2738H48.4848V46.5522H46.811H45.1415Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.811 17.2436H45.1415V15.5174H43.4677V17.2436V18.9652H45.1415V20.6914H46.811V22.413V24.1392H48.4848V22.413V20.6914V18.9652V17.2436V15.5174H46.811V17.2436Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4849 41.3782H46.811V43.1044H48.4849V41.3782Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.704 0H-0.017334V12.0651H11.704V0ZM10.0346 10.3434H1.67405V1.72165H10.0346V10.3434Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36051 3.44781H3.34332V8.62178H8.36051V3.44781Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7898 0V12.0651H48.4892V0H36.7898ZM46.8198 10.3434H38.4549V1.72165H46.8154L46.8198 10.3434Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 3.44781H40.1243V8.62178H45.1415V3.44781Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0171509 50H11.7042V37.9304H-0.0171509V50ZM1.6567 39.6521H10.0347V48.2738H1.67423L1.6567 39.6521Z",
    fill: "#46779B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36051 41.3782H3.34332V46.5522H8.36051V41.3782Z",
    fill: "#46779B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.4848,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.7b19ab922ea6d927ef6d3c1a5a05a5f2.svg";
export { ForwardRef as ReactComponent };